import React, { useEffect, useState } from 'react'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch, useSelector } from 'react-redux';
import { adaptionStatusComplete, adaptionStatusStart, fetchAdaption, fetchAdaptionQoute, fetchSingleAdaptionsForStaffMember, fetchSingleJobsForStaffMember, fetchSingleQoutationsForStaffMember, jobStatusComplete, jobStatusStart } from '../store/staffSlice';
import URL from '../functions/URLString';
import googleMaps from '../pictures/googleMaps.png'
import { json, useNavigate } from 'react-router-dom';
import StaffLogo from '../components/StaffLogo';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DescriptionIcon from '@mui/icons-material/Description';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DeleteIcon from '@mui/icons-material/Delete';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import InfoIcon from '@mui/icons-material/Info';
import MapIcon from '@mui/icons-material/Map';

function StaffDismantle() {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const queryParameters = new URLSearchParams(window.location.search)
  const id = queryParameters.get("id")
  const jobID = queryParameters.get("jobID")
  const type = queryParameters.get("type")
  const stateSingleAdaptionsForStaffMember = useSelector((state) => state.staff.singlejobsForStaffMember)
  const adaptionDetails = useSelector((state) => state.staff.adaptionDetails)
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [data, setData] = useState({jobDescription:"",job1:"",job2:"",jobDetails:"",status:0,adaptionDescription:"",requestedDate:"",partialDismantleDescription:"",completeDismantle:false});
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(()=>{
    dispatch(fetchSingleJobsForStaffMember({_id:jobID}))
    dispatch(fetchSingleQoutationsForStaffMember({_id:id,jobID,type}))
  },[])

  useEffect(()=>{
    if (JSON.stringify(stateSingleAdaptionsForStaffMember) !== "{}") {  
      setImages(stateSingleAdaptionsForStaffMember.Images || []);
      setData({
        ...data,
        jobDescription:stateSingleAdaptionsForStaffMember.jobDescription,
        job1:stateSingleAdaptionsForStaffMember.job1,
        job2:stateSingleAdaptionsForStaffMember.job2,
        jobDetails:stateSingleAdaptionsForStaffMember.jobDetails,
        status:stateSingleAdaptionsForStaffMember.status,
        requestedDate:adaptionDetails.dismantleRequestedDate,
        partialDismantleDescription:adaptionDetails.partialDismantleDescription,
        completeDismantle:adaptionDetails.completeDismantle
      });
      setIsLoading(false);
    }
  },[stateSingleAdaptionsForStaffMember,adaptionDetails])

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleImageSelect = (index) => {
    setCurrentImageIndex(index);
  };

  return (
    <div className='w-full h-screen bg-gray-50'>
      {/* Desktop Warning */}
      <div className='hidden lg:flex w-full h-screen items-center justify-center'>
        <div className="bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-lg shadow-lg max-w-lg">
          <strong className="font-bold text-lg">Warning!</strong>
          <p className="mt-2">This page is only visible on mobile and tablet devices.</p>
        </div>
      </div>

      {/* Mobile/Tablet Layout */}
      <div className='lg:hidden flex flex-col h-screen'>
        {/* Header */}
        <div className='bg-white shadow-sm px-4 py-3 flex items-center justify-between'>
          <div className='flex items-center space-x-3'>
            <button 
              onClick={() => navigate("/staffjoblist")} 
              className='text-gray-600 hover:text-red-500 transition-colors'
            >
              <ArrowBackIcon />
            </button>
            <div className='flex items-center space-x-2'>
              <DeleteIcon className='text-red-500' />
              <h1 className='text-xl font-semibold text-gray-800'>Dismantle Request</h1>
            </div>
          </div>
          <button 
            onClick={() => navigate("/staffjoblist")} 
            className='text-gray-500 hover:text-red-500 transition-colors'
          >
            <CloseIcon />
          </button>
        </div>

        {/* Main Content */}
        <div className='flex-1 overflow-y-auto'>
          {isLoading ? (
            <div className='flex items-center justify-center h-full'>
              <CircularProgress className='align-middle' size={60} color="success"/>
          </div>
          ) : (
            <>
              {/* Image Slider Section */}
              <div className='bg-white p-4'>
                {images.length > 0 ? (
                  <div className='space-y-4'>
                    {/* Main Image */}
                    <div className='relative aspect-[4/3] bg-gray-100 rounded-lg overflow-hidden'>
                      <img 
                        className='w-full h-full object-contain' 
                        src={`${URL}/uploads/${images[currentImageIndex]}`} 
                        alt={`Dismantle ${currentImageIndex + 1}`} 
                      />
                      
                      {/* Navigation Arrows */}
                      {images.length > 1 && (
                        <>
                          <button 
                            onClick={handlePrevImage}
                            className='absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors'
                          >
                            <ArrowBackIosNewIcon fontSize="small" />
                          </button>
                          <button 
                            onClick={handleNextImage}
                            className='absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors'
                          >
                            <ArrowForwardIosIcon fontSize="small" />
                          </button>
                        </>
                      )}
                      
                      {/* Image Counter */}
                      <div className='absolute bottom-2 right-2 bg-black/50 text-white px-2 py-1 rounded text-sm'>
                        {currentImageIndex + 1} / {images.length}
                      </div>
              </div>

                    {/* Thumbnail Gallery */}
                    {images.length > 1 && (
                      <div className='flex gap-2 overflow-x-auto pb-2 scrollbar-hide'>
                        {images.map((image, index) => (
                          <button
                            key={index}
                            onClick={() => handleImageSelect(index)}
                            className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all ${
                              currentImageIndex === index 
                                ? 'border-red-500 shadow-md' 
                                : 'border-gray-200 hover:border-gray-300'
                            }`}
                          >
                            <img 
                              src={`${URL}/uploads/${image}`} 
                              alt={`Thumbnail ${index + 1}`}
                              className='w-full h-full object-cover'
                            />
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className='aspect-[4/3] bg-gray-100 rounded-lg flex items-center justify-center'>
                    <p className='text-gray-500'>No images available</p>
                  </div>
                )}
              </div>

              {/* Dismantle Status Card */}
              <div className='mx-4 mb-4'>
                <div className='bg-white rounded-lg shadow-sm p-4 border-l-4 border-red-500'>
                  <div className='flex items-center space-x-3 mb-3'>
                    <DeleteIcon className="text-red-500" />
                    <div>
                      <h2 className='font-semibold text-gray-800'>Dismantle Request</h2>
                      <p className='text-sm text-red-600'>Ready for dismantling</p>
                    </div>
                  </div>
                  
                  <div className='grid grid-cols-1 gap-3'>
                    <div className='flex items-center space-x-3'>
                      <CalendarTodayIcon className='text-gray-400' fontSize="small" />
                      <div>
                        <p className='text-sm text-gray-500'>Requested Date</p>
                        <p className='font-medium text-gray-800'>{data.requestedDate || 'Not specified'}</p>
                      </div>
                    </div>
                    
                    <div className='flex items-center space-x-3'>
                      <InfoIcon className='text-gray-400' fontSize="small" />
                      <div>
                        <p className='text-sm text-gray-500'>Dismantle Type</p>
                        <p className={`font-medium ${data.completeDismantle ? 'text-red-600' : 'text-orange-600'}`}>
                          {data.completeDismantle ? 'Complete Dismantle' : 'Partial Dismantle'}
                        </p>
                      </div>
                    </div>
                </div>
                </div>
              </div>

              {/* Job Details Section */}
              <div className='mx-4 mb-4 space-y-4'>
                {/* Basic Details Card */}
                <div className='bg-white rounded-lg shadow-sm p-4 space-y-3'>
                  <h2 className='font-semibold text-gray-800 text-lg mb-3'>Job Information</h2>
                  
                  <div className='flex items-start space-x-3'>
                    <LocationOnIcon className='text-gray-400 mt-0.5' fontSize="small" />
                    <div className='flex-1'>
                      <p className='text-sm text-gray-500'>Address</p>
                      <p className='text-gray-800'>{data.job1} {data.job2}</p>
                    </div>
                  </div>

                  <div className='flex items-start space-x-3'>
                    <DescriptionIcon className='text-gray-400 mt-0.5' fontSize="small" />
                    <div className='flex-1'>
                      <p className='text-sm text-gray-500'>Description</p>
                      <p className='text-gray-800'>{data.jobDescription || 'No description available'}</p>
                    </div>
            </div>

                  <div className='flex items-start space-x-3'>
                    <AccessTimeIcon className='text-gray-400 mt-0.5' fontSize="small" />
                    <div className='flex-1'>
                      <p className='text-sm text-gray-500'>Access Details</p>
                      <p className='text-gray-800'>{data.jobDetails || 'No access details'}</p>
                    </div>
                  </div>
                </div>

                {/* Dismantle Details Card */}
                <div className='bg-white rounded-lg shadow-sm p-4'>
                  <h2 className='font-semibold text-gray-800 text-lg mb-3'>Dismantle Details</h2>
                  
                  <div className='space-y-3'>
                    <div className='bg-red-50 rounded-lg p-3 border border-red-200'>
                      <div className='flex items-start space-x-3'>
                        <InfoIcon className='text-red-500 mt-0.5' fontSize="small" />
                        <div className='flex-1'>
                          <p className='text-sm text-red-600 font-medium'>Dismantle Instructions</p>
                          <p className='text-gray-800 mt-1'>
                            {data.partialDismantleDescription || 'No specific instructions provided'}
                          </p>
                        </div>
                      </div>
                </div>

                    <div className='flex items-center justify-between p-3 bg-gray-50 rounded-lg'>
                      <span className='text-sm text-gray-600'>Dismantle Type</span>
                      <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                        data.completeDismantle 
                          ? 'bg-red-100 text-red-800' 
                          : 'bg-orange-100 text-orange-800'
                      }`}>
                        {data.completeDismantle ? 'Complete' : 'Partial'}
                      </span>
                </div>
                
                    {data.requestedDate && (
                      <div className='flex items-center justify-between p-3 bg-gray-50 rounded-lg'>
                        <span className='text-sm text-gray-600'>Requested Date</span>
                        <span className='font-medium text-gray-800'>{data.requestedDate}</span>
                </div>
                    )}
                </div>
                </div>
              </div>

              {/* Google Maps Link */}
              <div className='mx-4 mb-4'>
                <a 
                  href="https://www.google.com/maps" 
                  target="_blank" 
                  rel="noreferrer"
                  className='flex items-center justify-center space-x-3 bg-white rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow border border-gray-200 hover:border-blue-300'
                >
                  <MapIcon className='text-blue-500' />
                  <div className='text-center'>
                    <p className='font-medium text-gray-800'>Open Google Maps</p>
                    <p className='text-sm text-gray-500'>Navigate to job location</p>
                  </div>
                </a>
              </div>

              {/* Action Button */}
              <div className='mx-4 mb-4 pb-safe'>
                <button 
                  onClick={() => navigate("/staffjoblist")}
                  className='w-full px-6 py-3 bg-gray-600 hover:bg-gray-700 text-white rounded-lg font-medium transition-colors shadow-sm flex items-center justify-center space-x-2'
                >
                  <ArrowBackIcon fontSize="small" />
                  <span>Back to Dashboard</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default StaffDismantle